import tableChatLogo from "../../../assets/img/icon.png";
import { IconBrandX, IconBrandInstagram, IconBrandFacebook } from "@tabler/icons-react";

function Footer() {
  const socialLinks = [
    { href: "#", icon: IconBrandX, title: "X (Twitter)" },
    { href: "#", icon: IconBrandInstagram, title: "Instagram" },
    { href: "#", icon: IconBrandFacebook, title: "Facebook" },
  ];

  return (
    <footer className="bg-gradient-to-r from-[#ff1049] to-[#ff7826] text-white">
      <div className="container mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        
        {/* Logo + descripción corta */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <img 
            src={tableChatLogo} 
            alt="Logo TableChat" 
            className="w-10 mb-3 rounded-full" 
          />
          <p className="text-sm text-white/80 max-w-xs">
            Conectamos clientes y restaurantes sin meseros. Ordena rápido desde tu mesa.
          </p>
        </div>

        {/* Redes Sociales */}
        <div className="flex gap-4">
          {socialLinks.map((social, index) => {
            const IconComponent = social.icon;
            return (
              <a
                key={index}
                href={social.href}
                title={social.title}
                className="p-2 bg-white text-[#ff1049] rounded-full hover:scale-110 transition-transform duration-200 shadow-md"
              >
                <IconComponent size={18} strokeWidth={2} />
              </a>
            );
          })}
        </div>
      </div>

      {/* Enlaces legales */}
      <div className="border-t border-white/30 mt-6 pt-4 text-center">
        <div className="flex justify-center gap-6 mb-2">
          <a href="/legal/TermsOfService" className="text-white/80 text-xs hover:text-white transition-colors">
            Términos de Servicio
          </a>
          <a href="/legal/PrivacyPolicy" className="text-white/80 text-xs hover:text-white transition-colors">
            Política de Privacidad
          </a>
          <a href="/legal/CookiePolicy" className="text-white/80 text-xs hover:text-white transition-colors">
            Política de Cookies
          </a>
        </div>
        <p className="text-white/80 text-xs">
          © 2025 TableChat. Todos los derechos reservados
        </p>
      </div>
    </footer>
  );
}

export default Footer;
